<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div class="slds-grid">
  <div class="slds-col">
    <h2 class="slds-m-top_small slds-m-left_small slds-text-heading_medium">{{cd.label}}</h2>
    <h3 *ngIf="cd.subLabel" class="slds-m-left_small slds-text-heading_label">{{cd.subLabel}}</h3>
  </div>

  <div class="slds-col slds-align-bottom">
    <div class="slds-form-element">
      <label class="slds-checkbox_toggle slds-grid">
        <span class="slds-form-element__label slds-m-bottom_none" i18n>Layout</span>
        <input #checkbox
               (change)="onLayoutChange($event)"
               aria-describedby="toggle-desc"
               name="layout"
               type="checkbox" value="on">
        <span aria-live="assertive" class="slds-checkbox_faux_container" id="toggle-desc">
          <span class="slds-checkbox_faux"></span>
          <span class="slds-checkbox_on" i18n>Stacked</span>
          <span class="slds-checkbox_off" i18n>Layers</span>
        </span>
      </label>
    </div>
  </div>
</div>

<div *ngIf="isNoData"
     class="slds-p-top_small slds-p-left_small slds-text-color_weak" i18n>No data (yet)
</div>

<div #chart class="bar-chart-stacked"></div>
